import {useCallback} from 'react';
import endQuizSessionDoc from '../../api/quizSession/endQuizSessionDoc';
import {firebaseAuth} from '../../config/firebase';
import {useFunctionWrap} from '../helper/function/useFunctionWrap';

export default function useEndQuizSession() {
  const endFn = useCallback((sessionId: string) => {
    const uid = firebaseAuth.currentUser?.uid;
    if (!uid) throw new Error('Not authenticated');
    return endQuizSessionDoc(uid, sessionId);
  }, []);
  const {fn, loading, error} = useFunctionWrap(endFn);

  return {
    endQuizSession: fn,
    loading,
    error,
  };
}
